import $foreign from "./foreign.cjs";
var arrayMap = $foreign.arrayMap;
export { arrayMap };
